var _defs, _circle, _circle2, _path, _circle3, _path2, _path3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccupancyFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-3{fill:#231f20;}.cls-2{stroke:#231f20;stroke-width:13px;}.cls-2,.cls-3{stroke-linecap:round;stroke-miterlimit:10;}.cls-3{stroke:#fff;stroke-width:9px;}\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 255.11,
    cy: 186.93,
    r: 44.33
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.65,
    cy: 197.04,
    r: 33.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.37,308.25c-6.61-41.61-28.39-66.49-65.72-66.49-14.39,0-26.05,3.5-35.77,10.5a35.06,35.06,0,0,0,3.89,3.5c15.94,16.72,26.83,40.83,31.89,71.55,0,1.17.39,2.33.39,3.11C391.21,330.8,423.09,324.58,420.37,308.25Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 155.56,
    cy: 197.04,
    r: 33.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.84,255.75l3.5-3.5c-9.72-7-21.78-10.5-35.77-10.5-36.94,0-58.72,24.5-65.72,66.49-2.72,16.33,29.55,22.55,65.72,22.55a7.58,7.58,0,0,1,.39-3.11C160.62,297,171.5,272.86,187.84,255.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.11,359.58c-48.61,0-91.38-8.55-87.88-29.94,9.33-56,38.5-88.66,87.88-88.66S333.66,274,343,329.63C346.49,351,303.71,359.58,255.11,359.58Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 110,
    y1: 81.56,
    x2: 394.81,
    y2: 417.38
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 117.81,
    y1: 74.71,
    x2: 402.62,
    y2: 410.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupancyFull);
export default __webpack_public_path__ + "static/media/occupancyFull.448772f9da4222aa7b2353892bb93710.svg";
export { ForwardRef as ReactComponent };